import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskService, Task } from '../../services/task.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericConfirmationDialogComponent } from '../../shared/delete-confirmation-dialog/generic-confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-task-detail',
    templateUrl: './task-detail.component.html',
    styleUrls: ['./task-detail.component.sass'],
    standalone: false
})
export class TaskDetailComponent implements OnInit {
  task: Task | null = null;
  statusOptions = ['OPEN', 'CLOSED'];
  taskId: string;
  condominiumId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private taskService: TaskService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.taskId = this.route.snapshot.paramMap.get('taskId');
    this.condominiumId = this.route.parent.snapshot.paramMap.get('id');
    if (this.taskId) {
      this.taskService.getTaskDetails(Number(this.taskId)).subscribe({
        next: (task) => {
          this.task = task;
        },
        error: (error) => {
          console.error('Error fetching task:', error);
          this.snackBar.open('Erro ao carregar a tarefa', 'Fechar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(newStatus: string): void {
    if (!this.task) return;

    const dialogRef = this.dialog.open(GenericConfirmationDialogComponent, {
      data: {
        title: 'Confirmar mudança de status',
        message: `Mudar o status para ${newStatus === 'OPEN' ? 'ABERTO' : 'FECHADO'}?`,
        confirmButtonText: 'Confirmar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.taskService.updateTaskStatus(this.task!.id, newStatus).subscribe({
          next: (updatedTask) => {
            this.task = updatedTask;
            this.snackBar.open('Status atualizado com sucesso', 'Fechar', { duration: 3000 });
          },
          error: (error) => {
            console.error('Error updating task status:', error);
            this.snackBar.open('Erro ao atualizar o status', 'Fechar', { duration: 3000 });
          }
        });
      }
    });
  }

  onDelete(): void {
    if (!this.task) return;

    const dialogRef = this.dialog.open(GenericConfirmationDialogComponent, {
      data: {
        title: 'Confirmar exclusão',
        message: 'Tem certeza que deseja excluir esta tarefa?',
        confirmButtonText: 'Excluir'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.taskService.deleteTask(this.task!.id).subscribe({
          next: () => {
            this.snackBar.open('Tarefa excluída com sucesso', 'Fechar', { duration: 3000 });
            this.router.navigate([`/condominium/${this.condominiumId}/tasks`]);
          },
          error: (error) => {
            console.error('Error deleting task:', error);
            this.snackBar.open('Erro ao excluir a tarefa', 'Fechar', { duration: 3000 });
          }
        });
      }
    });
  }
}
